package com.mps.asc_app.data.user

/**
 * Alles, was die App direkt nach dem Login ueber den eingeloggten Nutzer wissen muss,
 * gelesen aus einem einzigen Abruf von users/{uid}.
 */
data class ApprovalProfile(
    val status: UserStatus,
    val forceAscMembershipForm: Boolean = false,
    val forcePadelMembershipForm: Boolean = false,
    val membershipRequestSubmitted: Boolean = false,
    val isAdmin: Boolean = false,
    val isTrainer: Boolean = false,
    val trainerAssignments: List<String> = emptyList(),
    /** Version der akzeptierten Datenschutz-Einwilligung, null wenn nicht akzeptiert. */
    val acceptedPrivacyConsentVersion: String? = null,
)
